import { relatorioDeCargaPatrimonial } from "@/reports/pdf/patrimonio/itembempermanente/relatoriodecargapatrimonial/index.js";
import { relatorioDeDadosCadastraisCargaPatrimonial } from "@/reports/pdf/patrimonio/itembempermanente/relatoriodedadoscadastraiscargapatrimonial/index.js";
import { relatorioDeCargaPatrimonialDetalhada } from "@/reports/pdf/patrimonio/itembempermanente/relatoriodecargapatrimonialdetalhada/index.js";
import { relatoriodepreciacao } from "@/reports/pdf/patrimonio/itembempermanente/relatoriodepreciacao/index.js";

export function geradorDePdf(type, ibp, title, relatorio) {
  switch (type) {
    case "rdIBPCP":
      relatorioDeCargaPatrimonial(ibp, title);
      break;
    case "rIBPDCCP":
      relatorioDeDadosCadastraisCargaPatrimonial(ibp, title);
      break;
    case "rIBPCPD":
      relatorioDeCargaPatrimonialDetalhada(ibp, title);
      break;

    case "rDIBP":
      relatoriodepreciacao(relatorio, title)
    default:
      break;
  }
}
